module.exports = __webpack_public_path__ + "img/fabao_bg.ebdd7789.png";